export default class ErrorService {
    static getMessageFromError(err, defaultMessage = "There was an error") {
        if (!err) {
            return defaultMessage;
        }
        if (typeof err === "string") {
            return err;
        }
        if (typeof err === "object" &&
            "message" in err &&
            typeof err.message === "string") {
            return err.message;
        }
        return defaultMessage;
    }
}
